import React from 'react';
import {Grid, Typography} from "@material-ui/core";

const Banner = props => (
  <div className="Banner" style={{
    backgroundColor:"rgb(58, 139, 104)",
    color: "white",
    marginTop: "1rem",
    marginBottom: "1rem",
  }}>
    <Grid container spacing={2}>
      <Grid item xs={4}><Typography>{props.title}</Typography></Grid>
      <Grid item xs={8}><Typography>{props.subTitle}</Typography></Grid>
    </Grid>
    
  </div>
  
);

export default Banner;


// WEBPACK FOOTER //
// ./src/pages/Banner.js